var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTophost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.42 104.815L60 100.963L49.58 104.815L45.9325 103.485L40.375 93.7125L29.94 89.8575L28.025 86.53L29.96 75.395L24.395 65.605L25.0575 61.8375L33.575 54.58L35.5075 43.4525L38.4625 40.965H49.555L58.0575 33.72H61.9475L70.45 40.965H81.5425L84.4975 43.4525L86.43 54.58L94.9475 61.8375L95.61 65.605L90.045 75.395L91.98 86.53L90.065 89.8575L79.63 93.7125L74.0725 103.485L70.425 104.815H70.42ZM58.96 94.9525H61.04L70.1125 98.305L74.9525 89.795L76.52 88.465L85.6375 85.095L83.9475 75.36L84.295 73.365L89.1675 64.7975L81.7125 58.4475L80.7025 56.6775L79.0175 46.9675H69.345L67.4 46.25L60.0025 39.9475L52.605 46.25L50.66 46.9675H40.9875L39.3025 56.6775L38.2925 58.4475L30.8375 64.7975L35.71 73.365L36.0575 75.36L34.3675 85.095L43.485 88.465L45.0525 89.795L49.8925 98.305L58.965 94.9525H58.96Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.93 47.0075L69.47 42.9925L89.265 21H76.3225L62.215 36.45L57.785 32.405L72.785 15.9775L75 15H96L98.23 20.0075L73.93 47.0075Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.07 47.0075L21.77 20.0075L24 15H45L47.215 15.9775L63.6525 33.9775L59.22 38.0225L43.6775 21H30.735L50.53 42.9925L46.07 47.0075Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTophost);
export default __webpack_public_path__ + "static/media/Tophost.b9c0a92e.svg";
export { ForwardRef as ReactComponent };